import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateDivisionMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createDivisionApi(data) {
    try {
      const api = `/division`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createDivisionApi", ...keyData],
    mutationFn: (data) => createDivisionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("divisions");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createDivision: mutateAsync };
}

export function useUpdateDivisionMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateDivisionApi(data) {
    try {
      const api = `/division`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateDivisionApi", ...keyData],
    mutationFn: (data) => updateDivisionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("divisions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateDivision: mutateAsync };
}

export function useDeleteDivisionMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteDivisionApi(id) {
    try {
      const api = `/division/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteDivisionApi", ...keyData],
    mutationFn: (data) => deleteDivisionApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("divisions");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteDivision: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllDivisionQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllDivisionApi(query) {
    try {
      const api = `/divisions${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllDivision-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllDivisionApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
